import React from "react";
import {
  getSportIcon,
  getGoalIcon,
  getSportIconColor,
  getStatusInformation,
  getScoreForArbs,
  getSubScoreForArbs,
  checkIfScoreChanged,
  getBetStatusInformation
} from "../../utils/events";
import {
  BetCardContainer,
  Match,
  FlexContainer,
  MatchOverview,
  SportIcon,
  EventNameText,
  PlacedBetsContainer,
  StatusBadge,
  LeagueNameText,
  ExtraArbsBadge,
  ScoreBadge,
  SubScoreBadge,
  StartTimeBadge,
  GoalIconContainer,
  GoalIcon,
  DivisionContainer,
  EventTextContainer,
  StatusContainer,
  CountryNameText
} from "./ValuebetEventCard.styled";
import { ValuebetCard } from "..";

export const ValuebetEventCard = ({ valuebets = [], event, setEvent, setPinnedValuebet, captureSnapshot, eventFiltered, pre = false, configuration, pinned = false }) => {
  const getDisplayableValuebets = () => {
    if (eventFiltered) return valuebets;
    if (valuebets.length === 0) return [];

    let firstValuebet;
    if (['timeAsc'].includes(configuration?.sortBy)) {
      const currentTimestamp = new Date().getTime();
      const valuebetsUpdatedOnTheLastSeconds = valuebets.filter(valuebet => currentTimestamp - valuebet.version < 5000)
      
      firstValuebet = valuebetsUpdatedOnTheLastSeconds.length > 0 ? valuebetsUpdatedOnTheLastSeconds.sort((a, b) => a.rawProfit - b.rawProfit)[0] : valuebets[0];
    } else  if (['timeDes'].includes(configuration?.sortBy)) {
      const firstValuebetTimestamp = valuebets[0].version;
      const valuebetsUpdatedOnTheLastSeconds = valuebets.filter(valuebet => Math.abs(firstValuebetTimestamp - valuebet.version) < 3000)
      
      firstValuebet = valuebetsUpdatedOnTheLastSeconds.length > 0 ? valuebetsUpdatedOnTheLastSeconds.sort((a, b) => a.rawProfit - b.rawProfit)[0] : valuebets[0];
    } else {
      firstValuebet = valuebets[0];
    }
    return [firstValuebet];
    // if (getBetStatusInformation(firstValuebet)) return [firstValuebet];

    // const firstValuebetWithStatus = valuebets.find(valuebet => valuebet.id !== firstValuebet.id && getBetStatusInformation(valuebet));

    // return firstValuebetWithStatus ? [firstValuebet, firstValuebetWithStatus] : [firstValuebet];
  }

  return (
    <BetCardContainer
      className="card"
      data-sport-name={event.sport?.name}
      onClick={() => setEvent(event)}
      status={event?.status}
      arbStatus={!eventFiltered ? valuebets[0]?.status : undefined}
    >
      <MatchOverview>
        <Match>
          <SportIcon src={getSportIcon(event.sport?.name)} filter={getSportIconColor(event.sport?.name)} />
          <EventTextContainer>
            <EventNameText className="event" data-event-name={event?.name}> {event?.name} </EventNameText>
            <DivisionContainer>
              {event?.league?.country && <CountryNameText className="country" data-country-name={event?.league?.country}>{event?.league?.country}</CountryNameText>}
              <LeagueNameText className="league" data-league-name={event?.league?.name}>{event?.league?.name}</LeagueNameText>
            </DivisionContainer>
            {
              <StatusContainer>
                {
                  !pre && !pinned && <>
                    <ScoreBadge className="badge badge-secondary">{getScoreForArbs(event)} </ScoreBadge>
                    {getSubScoreForArbs(event) && (
                      <SubScoreBadge className="badge badge-secondary">{getSubScoreForArbs(event)}</SubScoreBadge>
                    )}
                    {checkIfScoreChanged(event) &&
                      <GoalIconContainer className="badge badge-secondary">
                        <GoalIcon src={getGoalIcon(event.sport?.name)} />
                        <b>GOAL</b>
                      </GoalIconContainer>
                    }
                    {getStatusInformation(event) && (
                      <StatusBadge
                        className="badge"
                        status={event?.status}
                        arbStatus={!eventFiltered ? valuebets[0]?.status : undefined}
                      >
                        {" "}
                        {getStatusInformation(event)}{" "}
                      </StatusBadge>
                    )}
                  </>
                }
                {valuebets.length > 1 && (
                  <ExtraArbsBadge className="badge badge-secondary">
                    {" "}
                    +{valuebets.length - 1} {valuebets.length - 1 > 1 ? "Valuebets" : "Valuebet"}{" "}
                  </ExtraArbsBadge>
                )}
              </StatusContainer>
            }
          </EventTextContainer>
        </Match>
      </MatchOverview>
      { pre && !eventFiltered && 
      <MatchOverview>
        <FlexContainer>
          { event.startedAt && <StartTimeBadge className="badge">{new Date(event.startedAt).toLocaleString()}</StartTimeBadge> }
        </FlexContainer>
      </MatchOverview> 
      }
      <PlacedBetsContainer>
        {getDisplayableValuebets().map((valuebet) => (
          <ValuebetCard
            key={valuebet.id}
            valuebet={valuebet}
            captureSnapshot={captureSnapshot}
            event={event}
            setEvent={setEvent}
            setPinnedValuebet={setPinnedValuebet}
            pre={pre}
          />
        ))}
      </PlacedBetsContainer>
    </BetCardContainer>
  );
};
